import React, { useContext } from "react";
import { IntlContext } from "context";
import { ChipGroup } from "components/Form/Field";
import { BookingContext } from "app/OurService/Booking/Context";
import { useReferences } from "hooks/reference";

const TutoringFields: React.FC = () => {
    const intl = useContext(IntlContext);
    const reference = useReferences();
    const booking = useContext(BookingContext);
    const serviceData = booking.getService();
    const academicLevel = serviceData?.data.academic_level;
    const scholarSubject = serviceData?.data.scholar_subjects;
    const foreignLanguages = serviceData?.data.foreign_languages;
    const activities = serviceData?.data.activities;

    return (
        <div className="margin-top--4 space-y-6">
            {scholarSubject && (
                <ChipGroup
                    inputProps={{
                        name: "data.scholar_subjects",
                        required: true,
                        options:
                            serviceData?.data.scholar_subjects?.map((subjects) => {
                                return {
                                    label: reference.get("scholar_subject", subjects)?.value ?? subjects,
                                    value: subjects,
                                };
                            }) ?? [],
                    }}
                    labelProps={{
                        label: intl.formatMessage("service.label.subject"),
                    }}
                />
            )}

            {academicLevel && (
                <ChipGroup
                    inputProps={{
                        name: "data.academic_level",
                        required: true,
                        options:
                            serviceData?.data.academic_level?.map((levels) => {
                                return {
                                    label: reference.get("scholar_level", levels)?.value ?? levels,
                                    value: levels,
                                };
                            }) ?? [],
                    }}
                    labelProps={{
                        label: intl.formatMessage("service.label.academic_level"),
                    }}
                />
            )}

            {foreignLanguages && (
                <ChipGroup
                    inputProps={{
                        name: "data.foreign_languages",
                        required: true,
                        options:
                            serviceData?.data.foreign_languages?.map((language) => {
                                return {
                                    label: reference.get("foreign_languages", language)?.value ?? language,
                                    value: language,
                                };
                            }) ?? [],
                    }}
                    labelProps={{
                        label: intl.formatMessage("service.label.foreign_languages"),
                    }}
                />
            )}

            {activities && (
                <ChipGroup
                    inputProps={{
                        name: "data.activities",
                        required: true,
                        options:
                            serviceData?.data.activities?.map((activity) => {
                                return {
                                    label: reference.get("activity", activity)?.value ?? activity,
                                    value: activity,
                                };
                            }) ?? [],
                    }}
                    labelProps={{
                        label: intl.formatMessage("service.label.activity"),
                    }}
                />
            )}
        </div>
    );
};

export default TutoringFields;
